import React from "react";
import { Container, Table, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useJobContext } from "../../context/JobContext";

const Dashboard = () => {
    const { jobs, deleteJob, logout } = useJobContext();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/cms/login");
    };

    const handleDelete = (slug: string) => {
        if (window.confirm("Are you sure you want to delete this job?")) {
            deleteJob(slug);
        }
    };

    return (
        <div className="page-content py-5">
            <Container>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2>CMS Dashboard</h2>
                    <div>
                        <Link to="/cms/new" className="btn btn-success me-2">
                            Add New Job
                        </Link>
                        <Button variant="secondary" onClick={handleLogout}>
                            Logout
                        </Button>
                    </div>
                </div>

                <div className="bg-white p-4 rounded shadow-sm">
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th>Slug</th>
                                <th>Title</th>
                                <th>SubTitle</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(jobs).map(([slug, job]) => (
                                <tr key={slug}>
                                    <td>{slug}</td>
                                    <td>{job.title}</td>
                                    <td>{job.subTitle}</td>
                                    <td>
                                        <Link
                                            to={`/cms/edit/${slug}`}
                                            className="btn btn-sm btn-primary me-2"
                                        >
                                            Edit
                                        </Link>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleDelete(slug)}
                                        >
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            {Object.keys(jobs).length === 0 && (
                                <tr>
                                    <td colSpan={4} className="text-center">
                                        No jobs found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Container>
        </div>
    );
};

export default Dashboard;
